/* eslint-disable */
// /src/guards/MemberBlockGuard.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    onSnapshot,
    collection,
    query,
    where,
    limit as fsLimit,
} from "firebase/firestore";
import { db } from "../../services/firebase";
import { logout } from "../../services/authService";
import { useDriverStatusContext } from "../../context/DriverStatusContext";

const membersCol = collection(db, "members");

export default function MemberBlockGuard() {
    const navigate = useNavigate();
    const { phoneE164 } = useDriverStatusContext();

    useEffect(() => {
        let unsub = null;

        try {
            console.log("[MemberBlockGuard] effect enter, phoneE164 =", phoneE164);

            if (!phoneE164) {
                console.log("[MemberBlockGuard] no phoneE164 — skip subscribe");
                return;
            }

            const q = query(
                membersCol,
                where("phoneE164", "==", phoneE164),
                fsLimit(1)
            );

            console.log(
                "[MemberBlockGuard] subscribe members where phoneE164 =",
                phoneE164
            );

            unsub = onSnapshot(
                q,
                async (snap) => {
                    try {
                        console.log("[MemberBlockGuard] snapshot size =", snap.size);

                        if (snap.empty) {
                            // 문서를 못 찾으면 안전하게 튕겨낸다
                            console.log("[MemberBlockGuard] no member doc, force logout");
                            await safeLogout();
                            forceRedirect(navigate);
                            return;
                        }

                        const docSnap = snap.docs[0];
                        const data = docSnap.data() || {};
                        const memberStatus = data.memberStatus || data.status || "active";

                        console.log("[MemberBlockGuard] memberStatus =", memberStatus);

                        if (memberStatus === "rejected") {
                            console.log("[MemberBlockGuard] status=rejected → kick");
                            try {
                                alert(
                                    "이용이 제한된 계정입니다.\n자세한 내용은 관리자에게 문의해 주세요."
                                );
                            } catch (e) {
                                console.warn("[MemberBlockGuard] alert error", e);
                            }

                            await safeLogout();
                            forceRedirect(navigate);
                        }
                    } catch (cbErr) {
                        console.error(
                            "[MemberBlockGuard] onSnapshot callback error",
                            cbErr
                        );
                    }
                },
                (error) => {
                    console.error("[MemberBlockGuard] onSnapshot error", error);
                }
            );
        } catch (effectErr) {
            console.error("[MemberBlockGuard] effect setup error", effectErr);
        }

        return () => {
            try {
                console.log(
                    "[MemberBlockGuard] unsubscribe (phoneE164 =",
                    phoneE164,
                    ")"
                );
                if (typeof unsub === "function") {
                    unsub();
                }
            } catch (unsubErr) {
                console.error(
                    "[MemberBlockGuard] unsubscribe error",
                    unsubErr
                );
            }
        };
    }, [phoneE164, navigate]);

    return null;
}

async function safeLogout() {
    try {
        console.log("[MemberBlockGuard] safeLogout() called");
        await logout();
        console.log("[MemberBlockGuard] logout() finished");
    } catch (e) {
        console.warn("[MemberBlockGuard] logout() error", e);
    }

    try {
        if (typeof window !== "undefined") {
            window.localStorage.removeItem("dhm.session");
            console.log("[MemberBlockGuard] removed localStorage.dhm.session");
        }
    } catch (e) {
        console.warn("[MemberBlockGuard] local cleanup error", e);
    }
}

function forceRedirect(navigate) {
    try {
        console.log("[MemberBlockGuard] navigate('/loginlanding')");
        navigate("/loginlanding", { replace: true });
    } catch (e) {
        console.warn("[MemberBlockGuard] navigate error", e);
    }

    try {
        if (typeof window !== "undefined") {
            console.log("[MemberBlockGuard] hard redirect to /loginlanding");
            window.location.href = "/loginlanding";
        }
    } catch (e) {
        console.warn("[MemberBlockGuard] window.location redirect error", e);
    }
}
